import { Button, IconButton } from "@material-ui/core";
import AddIcon from "@material-ui/icons/Add";
import CloseIcon from "@material-ui/icons/Close";
import { FC } from "react";

const VariantsButton: FC<any> = ({ title, add = true, ...rest }) => {
  return (
    <>
      {add && title ? (
        <Button {...rest} variant="contained" startIcon={<AddIcon />}>
          {title}
        </Button>
      ) : (
        <IconButton {...rest}>
          <CloseIcon />
        </IconButton>
      )}
    </>
  );
};

export default VariantsButton;
